<template>
    <div class="document">
        <div class="document-top">
            <div class="document-top-status">
                <div class="document-top-status-router">
                    <span v-if="nav.length==1">全部文件</span>
                    <span v-else>
                        <span class="goBack cell cursor-pointer"  @click="navTo()">返回上一级</span><span class="line cell">|</span>
                        <span v-for="(item,index) in nav" :key="index">
                            <span :class="'cell cursor-pointer '+(index==(nav.length-1)?'last':'')" @click="navTo(item)">{{item.Name}}</span>
                            <span class="cell" v-if="index!=(nav.length-1)">></span>
                        </span>
                    </span>
                </div>
                <div class="document-top-status-router">
                    已加载全部，共{{data.length}}个
                </div>
            </div>
            <div class="document-top-check"> 
                <el-checkbox-group v-model="checkAll" @change="checkAllChange">
                    <el-checkbox label="全选" :value="true"></el-checkbox>
                </el-checkbox-group>
            </div>   
        </div>
        <div class="document-bottom">
            <div class="document-bottom-empty" v-if="data.length==0"><i class="icon icon-meiyoushuju"></i><span>没有数据</span></div>
            <div class="document-bottom-list clearfix" v-else>
                <div :class="'document-bottom-list-item cursor-pointer '+(item.checked?'checked':'')" @dblclick="dblclick(item)" @contextmenu.prevent="rightClick($event,item)" v-for="(item,index) in data" :key="index">
                    <div class="document-bottom-list-item-menu" v-if="item.showMenu" :style="{top:item.top+'px',left:item.left+'px'}">
                        <template v-for="(j,k) in btns">
                            <!--Audit 送审 -->
                            <div v-if="(item.AuditedStatus===3||item.AuditedStatus===1)&&j.ActionFlag==='audit'&&(userId===item.CreatorID)" class="menu-item" @click="menuClick(item,j)" :key="k"><template ><i :class="'icon '+j.IconCls"></i>{{j.Name}}</template></div>
                            <!-- Read 下载，操作记录，附件，只有非文件夹可操作 -->
                            <div v-else-if="(j.ActionFlag==='download'||j.ActionFlag==='operations'||j.ActionFlag==='attachView')&&item.FileExt" class="menu-item" @click="menuClick(item,j)" :key="k"><template ><i :class="'icon '+j.IconCls"></i>{{j.Name}}</template></div>
                            <!-- Read 查询操作，所有文件-->
                            <div v-else-if="j.ActionFlag!=='edit'&&j.ActionFlag!=='delete'&&j.ActionFlag!=='audit'&&j.ActionFlag!=='download'&&j.ActionFlag!=='operations'&&j.ActionFlag!=='attachView'&&j.ActionFlag!=='share'" class="menu-item" @click="menuClick(item,j)" :key="k"><template ><i :class="'icon '+j.IconCls"></i>{{j.Name}}</template></div>
                            <!-- Read 编辑，删除-->
                            <div v-else-if="(j.ActionFlag==='edit'||j.ActionFlag==='delete')&&(item.AuditedStatus===1||item.AuditedStatus===0||item.AuditedStatus===3)&&(userId===item.CreatorID)" class="menu-item" @click="menuClick(item,j)" :key="k"><template ><i :class="'icon '+j.IconCls"></i>{{j.Name}}</template></div>
                            <!-- 分享 -->
                            <div v-else-if="j.ActionFlag==='share'&&(item.AuditedStatus===4||item.AuditedStatus===0)&&item.FileExt&&(userId===item.CreatorID)" class="menu-item" @click="menuClick(item,j)" :key="k"><template ><i :class="'icon '+j.IconCls"></i>{{j.Name}}</template></div>
                        </template>
                        <div v-if="item.AuditedStatus!==0&&item.AuditedStatus!==1&&(userId===item.CreatorID)" class="menu-item" @click="menuClick(item,{ActionFlag:'status'})" ><template ><i :class="'icon icon-liucheng'"></i>审核流程</template></div>
                    </div>
                    <div @click="check(item)" class="document-bottom-list-item-close"><svg class="icon" aria-hidden="true"><use :xlink:href="'#icon-gouxuan'"></use></svg></div>
                    <div class="document-bottom-list-item-img"><svg class="icon" aria-hidden="true"><use :xlink:href="item|iconShow"></use></svg></div>
                    <div class="document-bottom-list-item-state" v-if="item.IsShare===1">共享</div>
                    <div :class="'document-bottom-list-item-auditState '+(item.AuditedStatus==3?'noPass':'')" v-if="item.AuditedStatus!==0">{{item.AuditedStatus|filterAuditStatus}}</div>
                    <div class="document-bottom-list-item-name">
                        <span><el-tooltip placement="top">
                        <div slot="content">
                            <div class="tip">{{item.FileExt?'文件名称':'文件夹名'}}：{{item.Name}}</div>
                            <div class="tip">发布部门：{{item.CreatorDeptName}}</div>
                            <div class="tip">发布人名：{{item.CreatorName}}</div>
                            <div class="tip">发布日期：{{item.CreateTime.split(' ')[0]}}</div>
                            <div class="tip" v-if="item.FileExt">文件大小：{{converMethod(item.FileSize)}}</div>
                            <div v-if="item.FileExt" class="tip">附件数量：{{item.AttachList?item.AttachList.length:0}}</div>
                            <template v-if="item.AttachList">
                                <div class="tip" v-for="(j,k) in item.AttachList" :key="k">附件({{k+1}})：{{j.Name+j.FileExt}}</div>
                            </template>
                        </div><i class="icon icon-question-circle"></i></el-tooltip>{{item.Name}}</span>
                    </div>
                    <div class="document-bottom-list-item-date"><span>{{item.CreateTime.split(' ')[0]}}</span></div> 
                </div>
                    
            </div>
        </div>
        <audit-process  v-if="auditProcessDialogVisible" :data="currentRow"  @closeCallback="auditProcessCloseCallback"></audit-process> 
    </div>
</template>

<script>
import {documentAuditRecord } from "@/api/document.js";
import AuditProcess from './AuditProcess'
import {conver} from '@/utils/index'
import store from '@/store'
export default {
  name: "DocumentMange",
  props:{
      data: {
        type: Array,
        default: [],
      },
      buttons:{
          type: Array,
          default: [],
      }
  },
   components:{
    AuditProcess
  },
  mounted() {
      this.userId = store.state.user.userInfo.UserID
    document.body.addEventListener("click", this.closeAllMenu);
  },
  destroyed(){
    document.body.removeEventListener("click", this.closeAllMenu);
  },
  data() {
    return {
      nav:[{
         Name:'全部文件',
          ID:0,
      }],
      currentRow:{},
      auditProcessDialogVisible:false,
      userId:{}
    };
  },
  computed:{
        checkAll:{
            get(){
                let num = 0;
                this.data.map((item,index)=>{
                    if(item.checked){
                        num++
                    }
                })
                if(num===this.data.length&&num!==0){
                    return true;
                }else{
                    return false;
                } 
            },
            set(val){
                this.data.map((item,index)=>{
                    this.$set(item,'checked',val)
                })
            },
            
        },
        btns(){
            let btns = this.buttons
            //let btns=[{Type:'view',Name:'预览',Icon:'icon-sanjiaoright'},{Type:'download',Name:'下载',Icon:'icon-phone'},{Type:'edit',Name:'编辑'},{Type:'delete',Name:'删除'},{Type:'audit',Name:'审核'},{Type:'attachUpload',Name:'上传附件'},{Type:'attachView',Name:'查看附件'},{Type:'share',Name:'共享'},{Type:'deleteShare',Name:'删除共享'},{Type:'operations',Name:'文档操作记录'}]
            return btns;
        },
  },
  methods: {
      converMethod(data){
        return conver(data)
        },
      auditProcessCloseCallback(){
        this.auditProcessDialogVisible=false;
        },
      navTo(item){
          if(item&&item.ID===0){//返回根节点
            this.$emit('queryRoot')
            this.init();
          }else if(item&&item.ID!==0){
                let newArr = [];
                let index = this.nav.findIndex((v) => {
                    newArr.push(v)
                    return item.ID===v.ID;
                });
                this.nav = newArr
                this.$emit('queryRoot',item.ID)
          }else{
            let item = this.nav[this.nav.length-2]
            let newArr = [];
            let index = this.nav.findIndex((v) => {
                newArr.push(v)
                return item.ID===v.ID;
            });
            this.nav = newArr
            this.$emit('queryRoot',item.ID)
          }
          
      },
      init(){
        this.nav = [{
            Name:'全部文件',
            ID:0,
        }]
      },
      dblclick(item){
          if(item.Type==1){//文件夹
          
            this.buttons.map((j,k)=>{
                if(j.ActionFlag=='view'){
                    this.nav.push(item)
                    this.$emit('menuClick',item,{ActionFlag:'view'})
                }
            })
            
          }else{

          }
      },
      menuClick(item,btn){
          if(btn.ActionFlag==='view'&&item.Type==1){
               this.nav.push(item)
          }
          if(btn.ActionFlag==='status'){
              this.auditProcessDialogVisible=true;
              this.currentRow = item
              return false;
          }
          this.$emit('menuClick',item,btn)
      },
      rightClick(e,item){
          this.closeAllMenu()
          this.$set(item,'left',e.target==e.currentTarget?e.offsetX:e.offsetX+30)
          this.$set(item,'top',e.target==e.currentTarget?e.offsetY:e.offsetY+0)
          this.$set(item,'showMenu',true)
      },
      closeAllMenu(){
          this.data.map((j,k)=>{
              this.$set(j,'showMenu',false)
          })
      },
      check(item){
          this.$set(item,'checked',!item.checked)
      },
      checkAllChange(val){
    },
    
  },
};
</script>
<style scoped lang="scss">
.tip{
    margin:10px 0;
}
.document{
    padding:10px;
    width:100%;
    height:100%;
    display: flex;
    color: #979797;
    font-size:14px;
    flex-direction: column;
    &-top{
        width:100%;
        display: flex;
        flex-direction: column;
        &-status{
            width:100%;
            display: flex;
            justify-content: space-between;
            &-router{
                .last{
                    color:black!important;
                }
                .cell{
                    color:#4e7bcc;
                    margin-right:6px;
                    display: inline-block;
                }
                
            }
        }
        &-check{
            margin:10px 0 5px 0 ;
            border-bottom:1px solid  #dbdbdb;
            padding-bottom: 5px;
        }
    }
    &-bottom{
        width:100%;
        height:100%;
        overflow: auto;
        &-empty{
            width:100%;
            height:100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size:20px;
            flex-direction: column;
            .icon{
                margin-bottom:20px;
                font-size:70px;
            }
        }
        &-list{
            width:100%;
            height:100%;
            overflow: auto;
            &-item:hover{
                background: rgb(241,245,250);
                .document-bottom-list-item-close{
                    display: block;
                }
            }
            .checked{
                background: #f1f5fa;
                border:1px solid #7dd8ff;
                .document-bottom-list-item-close{
                    display: block;
                    opacity: 1;
                }
            }
            &-item{
                width: 120px;
                height: 130px;
                float: left;
                margin: 4px 0 0 6px;
                text-align: center;
                border: 1px solid #fff;
                position: relative;
                padding: 10px;
                border-radius: 10px;
                user-select: none;
                
                &-close{
                    display: none;
                    position: absolute;
                    opacity: 0.2;
                    left: 0;
                    top: 0;
                    padding: 2px;
                    .icon{
                        font-size:20px
                    }
                }
                &-name{
                    
                    margin: 2px 0;
                    .icon{
                        margin-right:4px;
                    }
                    span{
                        overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                        height: 22px;
                        line-height:24px;
                        display: inline-block;
                        width: 100%;
                    }
                }
                &-img{
                    .icon{
                        font-size:71px;
                    }
                }
                &-state{
                    position: absolute;
                    right: -3px;
                    top: 2px;
                    color: red;
                    font-size: 12px;
                    transform: rotate(-27deg);
                    border: 1px solid red;
                }
                &-auditState{
                    position: absolute;
                    right: -3px;
                    top: 28px;
                    color: #409eff;
                    font-size: 12px;
                    -webkit-transform: rotate(-27deg);
                    transform: rotate(-27deg);
                    border: 1px solid #409eff;
                }
                .noPass{
                    color: red;
                    border: 1px solid red;
                }
                &-menu{
                        padding: 0 5px;
                    background: #f0f0f0;
                    border-radius: 5px;
                    box-shadow: 4px 2px 6px #dbdbdb;
                        min-width:92px;
                        position: absolute;
                        font-size:12px;
                        color: #464646;
                        z-index: 2;
                        overflow: hidden;
                    .menu-item:last-child{
                        border:none;
                    }
                    .menu-item:hover{
                        background: #409eff;
                        color: white;
                    }
                    .menu-item{
                        padding: 4px;
                        display: flex;
                        border-bottom: 1px solid #d7d7d7;
                        .icon{
                            margin-right: 2px;
                        }
                    }
                }
            }
        }
    }
}
    .icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    }
.dialog-content{
    height:300px;
    overflow: auto;;
}
</style>



// WEBPACK FOOTER //
// src/views/document/components/DocumentMange.vue